import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./shared/components/Loaders/Loaders.scss"
import reportWebVitals from "./reportWebVitals";
import "./shared/styles/shared.scss";
import { lazy } from "react";

import { BrowserRouter, Navigate } from "react-router";

import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { backUrl } from "./shared/shared";
import axios from "axios";
import App from "./App";
import { ToastContainer, Slide } from "react-toastify";
import {
  clearUserData,
  getLogin,
  redirectToLogin,
} from "./pages/Login/services/authService";
import { SafeRedirect } from "./shared/components/other/SafeRedirect";
import { ScrollToTop } from "./shared/components/other/ScrollToTop";
import { redirectToError502 } from "./shared/services/NavigationService";
import { displayNotify } from "./shared/services/Notifications/NotificationServices";

import Calendar from "./pages/Сalendar/Calendar";
import Login from "./pages/Login/Login";
import PaymentStatus from "./pages/CheckoutOrder/compontents/PaymentStatus";

const GameInfo = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "game-info" */ "./pages/GameInfo/GameInfo")
);
const Cabinet = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "cabinet" */ "./pages/Cabinet/Cabinet")
);
const TeamProfile = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "team-profile" */ "./pages/Team/TeamProfile")
);
const TeamsCalendar = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "teams-calendar" */ "./pages/TeamSearching/TeamsCalendar")
);
const DeviceOverviewPage = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "device-overview" */ "./pages/DevicesOverview/DeviceOverviewPage")
);

const LocationMeet = lazy(() => import("./pages/locationMeet/LocationMeet"));
const OrganizerPage = lazy(() => import("./pages/Organizer/OrganizerPage"));
const TeamEvents = lazy(() => import("./pages/Team/components/TeamEvents"));
const OrganizerEventsPage = lazy(() => import("./pages/OrganizerEventPage/OrganizerEventsPage"));
const OrganizersCalendar = lazy(() => import("./pages/Organizer/OrganizersCalendar"));
const EmailConfirm = lazy(() => import("./pages/EmailConfirm/components/EmailConfirm"));
const EmailVerification = lazy(() => import("./pages/EmailConfirm/components/EmailVerification"));
const Promo = lazy(() => import("./pages/Promo/Promo"));
const NewPasswordForm = lazy(() => import("./pages/Login/components/NewPasswordForm"));
const PasswordChangeRequestStatusPage = lazy(() => import("./pages/Login/components/PasswordChangeRequestStatusPage"));
const DevicePage = lazy(() => import("./pages/Shop/devices/DevicePage"));
const BuyForm = lazy(() => import("./pages/Shop/devices/BuyForm"));
const FeedbackPage = lazy(() => import("./pages/Feedback/FeedbackPage"));
const Error404Page = lazy(() => import("./pages/Errors/Error404Page/Error404Page"));
const MyPurchases = lazy(() => import("./pages/my-purchases/MyPurchases"))
const CheckoutOrder = lazy(() => import("./pages/CheckoutOrder/CheckoutOrder"))
const CheckoutSubscription = lazy(() => import("./pages/checkout-subscription/CheckoutSubscription"))


export const qClient = new QueryClient({});

axios.defaults.baseURL = backUrl;

// Перехватчик запросов для добавления JWT токена
axios.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (
      error.status === 401 ||
      (error.status === 403 &&
        error.response?.data?.detail?.toLowerCase().includes("csrf failed"))
    ) {
      clearUserData()
      redirectToLogin()
    }

    const requestMethod = error.config?.method

    const isCUD = ['POST', 'PUT', 'PATCH', 'DELETE', 'post', 'put', 'patch', 'delete'].includes(requestMethod) // Относится ли данный запрос к операциям создания\изменения\удаления

    console.log(isCUD)

    if (error.response?.status === 502 || error.status === 502) {
      if (error.config?.metadata?.skip502 || isCUD) {
        displayNotify({ title: 'Ошибка запроса', status: 'error', description: 'Проблемы соединения с сервером' })
        displayNotify({ title: 'Ошибка запроса', status: 'error', description: 'Проблемы соединения с сервером' })
      } else {
        redirectToError502();
      }
    }
    return Promise.reject(error);
  },
);


const routes = [
  { path: "/calendar", element: <Calendar /> }, // Календарь мероприятий
  { path: "/", element: <Calendar /> }, // Страница по умолчанию
  { path: "/register", element: <Login initialPage="register" /> }, //форма регистрации
  { path: "/login", element: <Login initialPage="login" /> }, //Страница авторизации
  { path: "/newpromo", element: <Promo /> }, //Промо страница
  { path: "/newpromo/:side", element: <Promo /> }, //Промо страни
  { path: "/promo", element: <Promo /> }, //Промо страница
  { path: "/promo/:side", element: <Promo /> }, //Промо страница
  { path: "/gameInfo", element: <Calendar /> }, //Информация о конкретном мероприятии
  { path: "/gameInfo/:guID", element: <GameInfo /> }, //Информация о конкретном мероприятии (если путсая - перенапралвение на календарь)
  { path: "/locationMeet", element: <Calendar /> }, // Информация о полигоне (если путсая - перенапралвение на календарь)
  { path: "/locationMeet/:guID", element: <LocationMeet /> }, // Информация о полигоне
  { path: "/cabinet", element: <SafeRedirect to={`/cabinet/${getLogin()}`} /> }, //Лк пользователя (если пользователь авторизован - его личный лк)
  { path: "/cabinet/:guID", element: <Cabinet /> }, //Лк конкретного пользователя
  { path: "/team", element: <Navigate to="/teams?my=true" /> }, //Страница команды (лк команды) (по умолчанию отображается основная)
  { path: "/team/:guID", element: <TeamProfile /> }, //Страница команды
  { path: "/organizer/", element: <Navigate to="/organizers?my=true" /> }, //Страница организаторов
  { path: "/organizer/:guID", element: <OrganizerPage /> }, //Страница организаторов
  { path: "/team/events", element: <TeamEvents /> }, //Мероприятия команды (название нужно поменять)
  { path: "/organizer/:guID/events", element: <OrganizerEventsPage /> }, //Мероприятия оргруппы
  { path: "/organizer/events", element: <OrganizerEventsPage /> }, //Мероприятия оргруппы
  { path: "/organizers", element: <OrganizersCalendar /> }, //Организаторы
  { path: "/teams", element: <TeamsCalendar /> }, // календарь команд
  { path: "/email/:status", element: <EmailConfirm /> }, //Окно подтвержденной/не подтвержденной почты
  { path: "/email/verification", element: <EmailVerification /> }, //окно со статусом запроса на подтверждение почты
  { path: "/passwordChangeRequest/:status", element: <PasswordChangeRequestStatusPage />, }, //Окно статуса запроса о сбросе пароля
  { path: "/resetpassword", element: <NewPasswordForm /> }, //Окно формы сброса пароля
  { path: "/device/:deviceId", element: <DevicePage /> }, //Страница покупки устройства, позже дорботать
  { path: "/devicesoverview", element: <DeviceOverviewPage /> }, //Страница со всеми устройствами
  { path: "/buy/:deviceId", element: <BuyForm /> }, // Страница формы покупки
  { path: "/feedback", element: <FeedbackPage /> }, //Страница обратной связи
  // { path: "/checkout", element: <CheckoutOrder /> }, //Страница для разработок фин сервиса
  { path: "/checkout-subscription", element: <CheckoutSubscription /> },
  { path: "/payment-status/:payment_id", element: <PaymentStatus/> },
  { path: "/purchases/:payment_status", element: <PaymentStatus/> },
  { path: "/payment-status/:payment_id", element: <PaymentStatus /> },
  // { path: "/purchases/success", element: <PaymentStatus /> },
  // { path: "/purchases/failed", element: <PaymentStatus /> },
  { path: "/my-purchases", element: <MyPurchases /> }, //Страница "Мои покупки"
  { path: "*", element: <Error404Page /> }
];
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={qClient}>
      <BrowserRouter>
        <ScrollToTop />
        <App routes={routes} />
        <ToastContainer
          transition={Slide}
          style={{ marginRight: "8px", zIndex: 100000 }}
          autoClose={false}
          draggable
          draggablePercent={40}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
